export const FATIGUE_PLAN = {
    STANDARD: 'standard',
    SPS: 'sps',
}